import Vue from 'vue';
import PressContactUs from '../../qaamgo//modules/sat/components/PressContactUs';
import 'bootstrap/js/dist/collapse';
import '../../../scss/critical.scss';
import '../../../scss/press.scss';

const $ = require('jquery');
global.$ = global.jQuery = $;

$(document).ready(function () {
    import(
        /* webpackMode: "eager" */
        '../qg-main'
    ).then(() => {
        new Vue({
            el: '#pressContactUsForm',
            name: 'PressContactUs',
            components: { PressContactUs },
            render(h) {
                return h(PressContactUs);
            },
        });
    });
});
